import { render, staticRenderFns } from "./deliveries.vue?vue&type=template&id=cd32bf54&scoped=true"
import script from "./deliveries.vue?vue&type=script&lang=js"
export * from "./deliveries.vue?vue&type=script&lang=js"
import style0 from "./deliveries.vue?vue&type=style&index=0&id=cd32bf54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd32bf54",
  null
  
)

export default component.exports